import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=6ef48c8a&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef48c8a",
  null
  
)

export default component.exports